import React, { useState, useRef, useEffect, useCallback } from "react";
import JoinFormPopup from "../component/JoinhereForm/joinhereForm";
import FeedbackFormPopup from "../component/FeedbackForm/feedbackForm";
import { useNavigate, useLocation  } from 'react-router-dom';
import { fetchlanguages } from "../api/api";
import SignupPopup from "./SignupPopup";
import { FiLogOut, FiLogIn   } from "react-icons/fi";
import { IoPerson    } from "react-icons/io5";
import { RiAdminFill } from "react-icons/ri";
import { IoMdSettings, IoMdHome   } from "react-icons/io";
import {convertUTCToLocalFormatted} from "../helper/index"


function Header({ oddsFormat, setOddsFormat, language, setLanguage, setToken, token, visible }) {
  const [showPopup, setShowPopup] = useState(false);
  const [feedbackPopup, setFeedbackPopup] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [languageData, setLanguageData] = useState([]);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const storedMode = localStorage.getItem("darkMode");
    return storedMode === "true";
  });
  const [activeComponent, setActiveComponent] = useState("best");
  const [showScrollLogo, setShowScrollLogo] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [showPopupSignup, setShowPopupSignup] = useState(false);
  const storedLoginData = sessionStorage.getItem("loginData");
  const parsedLoginData = storedLoginData ? JSON.parse(storedLoginData) : {};
  const location = useLocation();

  const userType = sessionStorage.getItem("usertypeid");
  // const userName = sessionStorage.getItem("username");

  const handleClose = () => setShowPopupSignup(false);


  // Sync isLoggedIn with token
  useEffect(() => {
    setIsLoggedIn(!!token);
  }, [token]);

  // Fetch languages
  useEffect(() => {
    const fetchLanguagData = async () => {
      try {
        const leagueResponse = await fetchlanguages(1, 5);
        setLanguageData([
          { langid: 30, language: "English", langcode: "en" },
          // Add more languages if needed
        ]);
      } catch (error) {
        console.error("Error fetching language data:", error);
      }
    };
    fetchLanguagData();
  }, []);

  

  // Close settings if clicked outside
  const settingsRefMobile = useRef(null);
  const settingsRefDesktop = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (
      (settingsRefMobile.current && settingsRefMobile.current.contains(event.target)) ||
      (settingsRefDesktop.current && settingsRefDesktop.current.contains(event.target))
    ) {
      // Clicked inside either dropdown → do nothing
      return;
    }

    setShowSettings(false);
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);

  // Dark mode
  useEffect(() => {
    document.body.classList.toggle("dark-mode", isDarkMode);
    localStorage.setItem("darkMode", isDarkMode);
  }, [isDarkMode]);

  // Scroll logo
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollLogo(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll to component
  useEffect(() => {
    const el = document.getElementById(`component-${activeComponent}`);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, [activeComponent]);

  const handleLogoClick = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const handleLogout = () => {
  const rememberMe = sessionStorage.getItem("rememberMe");
  const username = sessionStorage.getItem("username");

  // Clear everything first
  sessionStorage.clear();

  // If rememberMe was true, re-save username & rememberMe
  if (rememberMe === "true" && username) {
    sessionStorage.setItem("rememberMe", "true");
    sessionStorage.setItem("username", username);
  }

  setToken(null);
  setIsLoggedIn(false);
  navigate('/');
};

  // console.log(parsedLoginData.status , parsedLoginData.subscriptionstatus)

  return (
    <>
      <div className="AF-topHeader-row1 block md:hidden">
          <span
            className="home-icon"
            onClick={() => navigate("/")}
            title="Home"
          >
            <IoMdHome />
          </span>
          <button
            className="row_button"
            onClick={() => navigate("/pricing")}
          >
            <svg className="star-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ff8900" width="15" height="15">
              <path d="M12 .587l3.668 7.431L24 9.748l-6 5.853L19.336 24 12 20.201 4.664 24 6 15.601 0 9.748l8.332-1.73z" />
            </svg>
            <span>Go Pro</span>
            
            
          </button>
          {isLoggedIn ? (
            <>
              <span
                className="home-icon"
                onClick={() => navigate("/account")}
                title="Account"
              >
                <IoPerson  />
              </span>

              <span
                className="home-icon"
                onClick={handleLogout}
                title="Logout"
              >
                <FiLogOut />
              </span>

            </>
          ) : (
            <>
              {/* <button className="row1" onClick={() => setShowPopupSignup(true)}>Login</button> */}
              <span className="home-icon" onClick={() => setShowPopupSignup(true)} title="Login" >
                <FiLogIn  />
              </span>
            </>
          )}
          
          <span className="home-icon" onClick={() => setShowSettings(!showSettings)} title="setting" >
                <IoMdSettings />
          </span>

          {showSettings && (
            <div className="settings-dropdown"  ref={settingsRefMobile}>
              <div className="dropdown-section">
                <label htmlFor="language-select-mobile">Language</label>
                <select
                  id="language-select-mobile"
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                  className="custom-select"
                >
                  {languageData.length > 0 ? languageData.map((item, i) => (
                    <option key={i} value={item.langid}>{item.language}</option>
                  )) : <option disabled>Language not available</option>}
                </select>
              </div>
              <div className="dropdown-section">
                <div className="dropdown-options">
                  <button className={oddsFormat === "EU" ? "active" : ""} onClick={() => setOddsFormat("EU")}>EU</button>
                  <button className={oddsFormat === "US" ? "active" : ""} onClick={() => setOddsFormat("US")}>US</button>
                </div>
              </div>
              <div className="dropdown-section">
                <div className="dropdown-options">
                  <label>Light</label>
                  <label className="switch">
                    <input type="checkbox" checked={isDarkMode} onChange={() => setIsDarkMode(prev => !prev)} />
                    <span className="slider round"></span>
                  </label>
                  <label>Dark</label>
                </div>
              </div>
            </div>
          )}
          {userType === '1' && (
            // <button className="" onClick={() => navigate("/admin")}>Admin Panel</button>
            <span className="home-icon" onClick={() => navigate("/admin")} title="Admin Panel" >
                <RiAdminFill />
            </span>
          )}
      </div>

      <div className="AF-settings-wrapper" ref={settingsRefMobile}>
        {/* Mobile Header */}
        {location.pathname === "/" && (
        <div className="AF-topHeader-buttons block md:hidden">
          {["multi", "best", "treble"].map((comp) => (
            <button
              key={comp}
              className={activeComponent === comp ? "active" : ""}
              onClick={() => setActiveComponent(comp)}
            >
              {comp === "multi"
                ? "MultiBet"
                : comp === "best"
                ? "Bet Builder"
                : "Treble Win"}
            </button>
          ))}
        </div>
      )}
        
        {/* <div className="AF-topHeader-buttons block md:hidden">
          {["multi", "best", "treble"].map((comp) => (
            <button
              key={comp}
              className={activeComponent === comp ? "active" : ""}
              onClick={() => setActiveComponent(comp)}
            >
              {comp === "multi" ? "MultiBet" : comp === "best" ? "Bet Builder" : "Treble Win"}
            </button>
          ))}
          
        </div> */}

        {/* Desktop Header */}
        <div className="AF-topHeader">
          <div className="AF-container">
            <div className="grid-noGutter-middle">
              <div className="col-6"></div>
              <div className="col-6 right-align">
                <button
                  className={`go-pro-btn ${location.pathname === "/" ? "active" : ""}`}
                  onClick={() => navigate("/")}
                >
                  Home
                </button>
                <button className={`go-pro-btn ${location.pathname === "/pricing" ? "active" : ""}`} onClick={() => navigate("/pricing")} title="Unlock all features with Pro (£4.99/month)">
                  Go Pro
                  <svg
                    className="star-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill={location.pathname === "/pricing" ? "#FFF" : "#ff8900"}
                    width="10"
                    height="10"
                  >
                    <path d="M12 .587l3.668 7.431L24 9.748l-6 5.853L19.336 24 12 20.201 4.664 24 6 15.601 0 9.748l8.332-1.73z" />
                  </svg>

                </button>
                {isLoggedIn ? (
                  <>
                    <button
                      className={`go-pro-btn ${location.pathname === "/account" ? "active" : ""}`}
                      onClick={() => navigate("/account")}
                    >
                      My Account
                    </button>
                    <button className="AF-settings-button-login" onClick={handleLogout}>Logout</button>
                  </>
                ) : (
                  <>
                    <button className="AF-settings-button-login" onClick={() => setShowPopupSignup(true)}>Login</button>
                    {/* <button className="AF-settings-button-login" onClick={() => navigate("/signup")}>Signup</button> */}
                  </>
                )}
                {/* <button
                    className={`AF-settings-button`}
                    onClick={() => setShowSettings(!showSettings)}
                  >
                    <SettingsIcon />
                  </button> */}
                  <span className="home-icon-desk" onClick={() => setShowSettings(!showSettings)} title="setting" >
                    <IoMdSettings />
                  </span>



                {showSettings && (
                  <div className="settings-dropdown" ref={settingsRefDesktop}>
                    <div className="dropdown-section">
                      <label htmlFor="language-select">Language</label>
                      <select id="language-select" value={language} onChange={(e) => setLanguage(e.target.value)} className="custom-select">
                        {languageData.length > 0 ? languageData.map((item, i) => (
                          <option key={i} value={item.langid}>{item.language}</option>
                        )) : <option disabled>Language not available</option>}
                      </select>
                    </div>
                    <div className="dropdown-section">
                      <div className="dropdown-options">
                        <button className={oddsFormat === "EU" ? "active" : ""} onClick={() => setOddsFormat("EU")}>EU</button>
                        <button className={oddsFormat === "US" ? "active" : ""} onClick={() => setOddsFormat("US")}>US</button>
                      </div>
                    </div>
                    <div className="dropdown-section">
                      <div className="dropdown-options">
                        <label>Light</label>
                        <label className="switch">
                          <input type="checkbox" checked={isDarkMode} onChange={() => setIsDarkMode(prev => !prev)} />
                          <span className="slider round"></span>
                        </label>
                        <label>Dark</label>
                      </div>
                    </div>
                    {userType === '1' && (
                      <button className="AF-settings-admin-btn" onClick={() => {
                        navigate("/admin");
                        setShowSettings(!showSettings);
                      }}>Admin Panel</button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Beta Message */}
      {visible && (
        parsedLoginData.status === "Active" &&
        parsedLoginData.subscriptionstatus === "Cancelled" ? (
          // Cancelled subscription banner
          <div className="AF-container beta-hide">
            <div className="beta-message">
              <p>
                You’ll keep Pro access until {convertUTCToLocalFormatted(parsedLoginData.subscriptionenddate)}, after which you’ll move to the 
                {parsedLoginData.nextsubscription === null ? ' Free plan.': ` ${parsedLoginData.nextsubscription} plan starting on ${convertUTCToLocalFormatted(parsedLoginData.nextsubscriptionstartdate)}.`}
              </p> 
            </div>
          </div>
        ) : parsedLoginData.product === "Pro" ? (
          // Pro subscription banner
          <div className="AF-container beta-hide">
            <div className="beta-message">
              <p>
                You’re on the <strong>Pro plan</strong>. Enjoy full access to all features!
              </p>
            </div>
          </div>
        ) : (
          // Promotional banner
          <div className="AF-container beta-hide">
            <div className="beta-message">
              <p>
                Pro is now live! Unlock full access for just £4.99/month.{" "}
                <strong>
                  <a href="/pricing" className="beta-link">See Plans</a>
                </strong>
                .
              </p>
            </div>
          </div>
        )
      )}



      {/* Popups */}
      {showPopup && <JoinFormPopup onClose={() => setShowPopup(false)} />}
      {feedbackPopup && <FeedbackFormPopup onClose={() => setFeedbackPopup(false)} />}
      {showScrollLogo && (
        <div className="scroll-logo" onClick={handleLogoClick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M8 12a.5.5 0 0 1-.5-.5V4.707L4.354 8.854a.5.5 0 1 1-.708-.708l4.5-4.5a.5.5 0 0 1 .708 0l4.5 4.5a.5.5 0 0 1-.708.708L8.5 4.707V11.5A.5.5 0 0 1 8 12z" />
          </svg>
        </div>
      )}
      {showPopupSignup && (
        <SignupPopup
          showPopup={showPopupSignup} 
          handleClose={handleClose}
          setToken={setToken}
          hederLogin={true}
        />
      )}

    </>
  );
}


export default Header;
